import { Component, Input } from '@angular/core';

@Component({
  selector: 'aum-cli-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  @Input() isLoading = false;
}
